export default __webpack_public_path__ + "static/media/Calendar-gray.71762d54.svg";